export interface SSOLoginDetails {
	token: string;
}

export class SSOLoginDetails implements SSOLoginDetails {
	constructor(token: string) {
		this.token = token;
	}
}